export default __webpack_public_path__ + "static/media/empty-state-maintenance.6ec12c66.svg";